import React, { useState } from 'react';
import { Button, Icon, Input, Label, Dimmer, Loader } from 'semantic-ui-react';
import DisplaySubscriptionPaymentMethod from './displayCard';
const ShowCreditCard = ({ paymentMethod, setOpenCheckoutModal, isEditCardOpen, paymentManagerId, deleteCard }) => {
    return paymentMethod ? (
        !isEditCardOpen ? (
            <DisplaySubscriptionPaymentMethod paymentMethod={paymentMethod} deleteCard={deleteCard} />
        ) : (
            <></>
        )
    ) : !isEditCardOpen ? (
        <Button
            large
            basic
            onClick={() => {
                setOpenCheckoutModal(true);
            }}
            className="add-card-button"
            color="blue"
        >
            <Icon name="add" />
            Add Card
        </Button>
    ) : (
        <></>
    );
};

export default ShowCreditCard;
